module.exports = __webpack_public_path__ + "static/hero-career-b2bfd10f6935b525c9f33939c19a69c7.svg";